import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export function initChangeStoreLink(links) {
  // Open popin on click
  if (links.length) links.forEach(function (link) {
    var isInDeliveryModal = link.closest('.js-delivery-modal') ? true : false;
    link.addEventListener("click", function () {
      if (!isInDeliveryModal) window.dispatchEvent(new CustomEvent("openStoreContextLayerInSearchMode"));
    });
  });
  if (links.length && typeof tc_vars != "undefined" && tc_vars) {
    var action = [];
    var actionKeys = ["env_type_contenu", "env_type_page", "env_soustype"];
    actionKeys.forEach(function (key) {
      if (tc_vars[key] && tc_vars[key] !== "") action.push(tc_vars[key]);
    });
    var label = [];
    var labelKeys = ["page_cat1_label", "page_cat2_label", "page_cat3_label", "page_cat4_label"];
    labelKeys.forEach(function (key) {
      if (tc_vars[key] && tc_vars[key] !== "") label.push(tc_vars[key]);
    });
  }
}
export function initChangeStoreLinkWithStock(links) {
  // Open popin on click
  if (links.length) links.forEach(function (link) {
    var isInDeliveryModal = link.closest('.js-delivery-modal') ? true : false;
    var productRef = document.querySelector('.js-product-ref').innerHTML;
    link.addEventListener("click", function () {
      if (!isInDeliveryModal) window.dispatchEvent(new CustomEvent('openStoreContextLayerInSearchMode', {
        'detail': productRef
      }));
    });
  });
}